import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Skeleton } from "@mui/material";
import styles from "./CurrentConversation.module.css";
import { IconComponent, InfiniteList2 } from "../../../../common/components";
import { ConversationBox, ConversationPropositions, UserGuide } from "..";
import aitendersWhiteLogo from "../conversation-box/images/aitendersWhiteLogo.svg";
import SourceSidePanel from "./SourceSidePanel";

const CurrentConversation = ({
	chatPayload = "",
	loading = false,
	onChangeTextFilter,
	onGetChat,
	selectedChat = 0,
}) => {
	const cautionBannerDisabled = useSelector(({ context }) => context.cautionBannerHidden);
	const projectId = useSelector(({ context }) => context.project?.id);
	const [request, setRequest] = useState(null);
	const [openSidePanel, setOpenSidePanel] = useState(false);
	const [idChatAnswer, setIdChatAnswer] = useState(null);
	useEffect(() => {
		if (projectId && selectedChat) {
			setRequest(
				() =>
					({ page, limit }) =>
						onGetChat({ projectId, chatId: selectedChat }, { page, limit })
			);
		} else {
			setRequest(null);
		}
	}, [onGetChat, projectId, selectedChat]);
	const handleCloseSidePanel = () => {
		setOpenSidePanel(false);
	};
	const handleOpenSidePanel = (chatId) => {
		setOpenSidePanel(chatId);
	};
	const rowRenderer = (conversation) => (
		<ConversationBox
			key={conversation.id}
			conversation={conversation}
			setIdChatAnswer={setIdChatAnswer}
			onOpenSidePanel={handleOpenSidePanel}
		/>
	);
	return (
		<div className={styles.container} data-chat-active={selectedChat !== 0 || loading}>
			<div className={styles.conversationChat} data-caution-banner-disabled={cautionBannerDisabled}>
				{selectedChat !== 0 && (
					<InfiniteList2
						reversedScroll
						className={styles.infiniteList}
						request={request}
						rowRenderer={rowRenderer}
						scrollContainerClassName={styles.infiniteList__scrollContainer}
					/>
				)}
				{selectedChat === 0 && !loading && (
					<div className={styles.userGuide}>
						<UserGuide />
					</div>
				)}
			</div>
			{loading && (
				<>
					<ConversationBox
						conversation={{ id: selectedChat, content: chatPayload }}
						setIdChatAnswer={setIdChatAnswer}
						onOpenSidePanel={handleOpenSidePanel}
					/>
					<div className={styles.loading_answer}>
						<IconComponent autoTranslate="no" className={styles.conversation__icon}>
							<img alt="aitenders_logo" height="18px" src={aitendersWhiteLogo} width="22px" />
						</IconComponent>
						<Skeleton className={styles.skeleton} sx={{ fontSize: "2rem" }} />
					</div>
				</>
			)}
			<div className={styles.conversation_proposition}>
				{selectedChat === 0 && !loading && <ConversationPropositions onChangeTextFilter={onChangeTextFilter} />}
			</div>
			<SourceSidePanel
				idChatAnswer={idChatAnswer}
				open={!!openSidePanel}
				selectedChat={selectedChat}
				onClose={handleCloseSidePanel}
			/>
		</div>
	);
};

export default CurrentConversation;
